// skipcq: JS-W1028

const EMPTY_DISPLAY = '—';

function parseTargetTypeFromScheduleId(scheduleId) {
  if (scheduleId == null || String(scheduleId).trim() === '') {
    return '';
  }
  const segments = String(scheduleId).split('__');
  if (segments.length >= 3) {
    return segments[1];
  }
  return '';
}

export function resolveEffectiveTargetType(row) {
  const fromDoc =
    row?.targetType != null && String(row.targetType).trim() !== ''
      ? String(row.targetType).trim()
      : '';
  if (fromDoc) {
    return fromDoc;
  }
  return parseTargetTypeFromScheduleId(row?.scheduleId);
}

function hasEntiteaResult(entiteaResult) {
  if (entiteaResult == null) {
    return false;
  }
  if (typeof entiteaResult === 'string') {
    return entiteaResult.trim() !== '';
  }
  return true;
}

/**
 * True when the executions table should show Compare for this row.
 */
export function canShowExecutionCompare(row) {
  if (!row) {
    return false;
  }
  if (row.crawlType !== 'google_maps_search') {
    return false;
  }
  if (row.outcome !== 'no match') {
    return false;
  }
  if (resolveEffectiveTargetType(row) !== 'brewery') {
    return false;
  }
  const targetId = row.targetId;
  if (targetId == null || String(targetId).trim() === '') {
    return false;
  }
  return hasEntiteaResult(row.entiteaResult);
}

function formatFieldValue(value) {
  if (value == null || value === '') {
    return EMPTY_DISPLAY;
  }
  return String(value);
}

/**
 * Multi-line brewery address for compare dialog.
 */
export function formatBreweryAddress({ address1, city, state, zip }) {
  const lines = [address1, city, state, zip]
    .map((part) => (part == null ? '' : String(part).trim()))
    .filter((part) => part.length > 0);
  if (lines.length === 0) {
    return EMPTY_DISPLAY;
  }
  return lines.join('\n');
}

const DATE_ONLY_PATTERN = /^(\d{4})-(\d{2})-(\d{2})$/;

function isValidLocalCalendarDate(year, month, day) {
  const localDate = new Date(year, month - 1, day);
  return (
    localDate.getFullYear() === year &&
    localDate.getMonth() === month - 1 &&
    localDate.getDate() === day
  );
}

function formatOobDate(oobDate) {
  if (!oobDate) {
    return '';
  }
  if (oobDate instanceof Date) {
    if (Number.isNaN(oobDate.getTime())) {
      return '';
    }
    return oobDate.toLocaleDateString();
  }
  const dateString = String(oobDate).trim();
  const dateOnlyMatch = DATE_ONLY_PATTERN.exec(dateString);
  if (dateOnlyMatch) {
    const year = Number(dateOnlyMatch[1]);
    const month = Number(dateOnlyMatch[2]);
    const day = Number(dateOnlyMatch[3]);
    if (!isValidLocalCalendarDate(year, month, day)) {
      return '';
    }
    return new Date(year, month - 1, day).toLocaleDateString();
  }
  const parsed = new Date(oobDate);
  if (!Number.isNaN(parsed.getTime())) {
    return parsed.toLocaleDateString();
  }
  return '';
}

/**
 * Human-readable closure status for compare dialog.
 */
export function formatBreweryClosureStatus({ isOob, isTempClosed, oobDate }) {
  if (isOob) {
    const dateSuffix = formatOobDate(oobDate);
    return dateSuffix ? `Permanently closed (${dateSuffix})` : 'Permanently closed';
  }
  if (isTempClosed) {
    return 'Temporarily closed';
  }
  return 'Open';
}

export function formatBreweryCompareField(value) {
  return formatFieldValue(value);
}

/**
 * Pretty-print EntiTea result JSON for the compare dialog.
 */
export function formatEntiteaResultJson(entiteaResult) {
  if (entiteaResult == null || entiteaResult === '') {
    return EMPTY_DISPLAY;
  }
  if (typeof entiteaResult === 'string') {
    const trimmed = entiteaResult.trim();
    if (trimmed === '') {
      return EMPTY_DISPLAY;
    }
    try {
      const parsed = JSON.parse(trimmed);
      return JSON.stringify(parsed, null, 2);
    } catch {
      return trimmed;
    }
  }
  try {
    return JSON.stringify(entiteaResult, null, 2);
  } catch {
    return String(entiteaResult);
  }
}
